<ion-content>
    <div style="display: flex; flex-direction: column; height: 100vh; width: 100vw;">
        <div class="ds-accounts-body">
            <div class="ds-accounts-body-box">
                <div class="ds-accounts-body-box-title">
                    <!--Introduce tus datos-->
                    {{ 'INTRODUCE_YOUR_DATA' | translate }}
                </div>

                <form [formGroup]="userForm" class="ds-accounts-body-box-form">
                    <!-- Email Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            <!--Email-->
                            {{ 'EMAIL' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="email" placeholder="Introduce tu correo electrónico" label="Correo electrónico" label-placement="stacked" formControlName="email">
                            <div *ngIf="errorControl['email']?.invalid && (errorControl['email']?.dirty || errorControl['email']?.touched)" class="error-message">
                                <span *ngIf="errorControl['email']?.errors?.['required']">{{ 'EMAIL_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['email']?.errors?.['email']">{{ 'EMAIL_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Name Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'NAME' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu nombre completo (nombre y apellidos)" formControlName="name">
                            <div *ngIf="errorControl['name']?.invalid && (errorControl['name']?.dirty || errorControl['name']?.touched)" class="error-message">
                                <span *ngIf="errorControl['name']?.errors?.['required']">{{ 'NAME_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['name']?.errors?.['minlength'] || errorControl['name']?.errors?.['maxlength']">{{ 'NAME_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Add similar error message blocks for the remaining fields -->
                    <!-- For demonstration, I'll add it for the phone field as well -->

                    <!-- Phone Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'PHONE' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu teléfono" formControlName="phone">
                            <div *ngIf="errorControl['phone']?.invalid && (errorControl['phone']?.dirty || errorControl['phone']?.touched)" class="error-message">
                                <span *ngIf="errorControl['phone']?.errors?.['required']">{{ 'PHONE_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['phone']?.errors?.['pattern']">{{ 'PHONE_PATTERN_INVALID' | translate }}</span>
                                <span *ngIf="errorControl['phone']?.errors?.['minlength'] || errorControl['phone']?.errors?.['maxlength']">{{ 'PHONE_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- NIF/CIF Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'NIF_OR_CIF' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce el nif/cif propio o de tu empresa" formControlName="nif">
                            <div *ngIf="errorControl['nif']?.invalid && (errorControl['nif']?.dirty || errorControl['nif']?.touched)" class="error-message">
                                <span *ngIf="errorControl['nif']?.errors?.['required']">{{ 'NIF_OR_CIF_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['nif']?.errors?.['minlength'] || errorControl['nif']?.errors?.['maxlength']">{{ 'NIF_OR_CIF_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Company Name Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'COMPANY_NAME_OR_PERSON_NAME' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce el nombre de tu empresa" formControlName="companyName">
                            <div *ngIf="errorControl['companyName']?.invalid && (errorControl['companyName']?.dirty || errorControl['companyName']?.touched)" class="error-message">
                                <span *ngIf="errorControl['companyName']?.errors?.['required']">{{ 'COMPANY_NAME_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['companyName']?.errors?.['minlength'] || errorControl['companyName']?.errors?.['maxlength']">{{ 'COMPANY_NAME_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Country Field -->
                    <div class="ds-input-primary" #triggerInput>
                        <div class="ds-input-primary-label">
                            
                            {{ 'COUNTRY' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu país" formControlName="country" (click)="onExtensionSelectorClick($event)" (input)="setSearchTerm($event)" id="countryInput">
                            <div *ngIf="errorControl['country']?.invalid && (errorControl['country']?.dirty || errorControl['country']?.touched)" class="error-message">
                                <span *ngIf="errorControl['address']?.errors?.['required']">{{ 'COUNTRY_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['country']?.errors?.['minlength'] || errorControl['country']?.errors?.['maxlength']">{{ 'COUNTRY_LENGTH_INVALID' | translate }}</span>
                                <span *ngIf="errorControl['country']?.errors?.['invalidCountryName']">{{ 'COUNTRY_INVALID_NAME' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- City Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'CITY' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu ciudad" formControlName="city">
                            <div *ngIf="errorControl['city']?.invalid && (errorControl['city']?.dirty || errorControl['city']?.touched)" class="error-message">
                                <span *ngIf="errorControl['address']?.errors?.['required']">{{ 'CITY_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['city']?.errors?.['minlength'] || errorControl['city']?.errors?.['maxlength']">{{ 'CITY_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'POSTAL_CODE' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu Código Postal" formControlName="cp">
                            <div *ngIf="errorControl['cp']?.invalid && (errorControl['cp']?.dirty || errorControl['cp']?.touched)" class="error-message">
                                <span *ngIf="errorControl['cp']?.errors?.['required']">{{ 'POSTAL_CODE_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['cp']?.errors?.['minlength'] || errorControl['cp']?.errors?.['maxlength']">{{ 'POSTAL_CODE_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Address Field -->
                    <div class="ds-input-primary">
                        <div class="ds-input-primary-label">
                            {{ 'ADDRESS' | translate }}
                        </div>
                        <div class="ds-input-primary-content">
                            <input type="text" placeholder="Introduce tu dirección" formControlName="address">
                            <div *ngIf="errorControl['address']?.invalid && (errorControl['address']?.dirty || errorControl['address']?.touched)" class="error-message">
                                <span *ngIf="errorControl['address']?.errors?.['required']">{{ 'ADDRESS_REQUIRED' | translate }}</span>
                                <span *ngIf="errorControl['address']?.errors?.['minlength'] || errorControl['address']?.errors?.['maxlength']">{{ 'ADDRESS_LENGTH_INVALID' | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="ds-accounts-body-box-form-button">
                        <button class="ds-button-secondary" type="submit" (click)="logout()">
                            {{ 'LOGOUT' | translate }}
                        </button>

                        <button class="ds-button-primary" type="submit" [disabled]="!this.userForm.valid" (click)="onSubmit()">{{ 'SAVE_DATA' | translate }}</button>
                    </div>
                </form>
            </div>

            <div class="ds-accounts-body-box ds-accounts-body-payment" *ngIf="userData?.totalumInstances?.length! > 0">
        
                <div class="ds-accounts-body-box-title">
                    {{ 'YOUR_PLANS' | translate }}
                </div>

                <br>

                <div class="ds-accounts-plan" *ngFor="let instance of userData?.totalumInstances">
                    <div class="ds-accounts-plan-header">
                        <div class="ds-accounts-plan-header-left">
                            <div class="ds-accounts-plan-header-left-totalumlogo">
                                <img src="assets/totalum-logo-recortado.png" alt="Logo">
                            </div>
                            <div class="ds-accounts-plan-header-left-totalumname">
                                {{instance.organizationId}}
                            </div>
                        </div>
                        <div class="ds-accounts-plan-header-right">
                            <div class="ds-chip">Plan&nbsp;<span class="ds-chip-plan"> {{instance?.plan}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="ds-accounts-plan-content">
                        <div class="ds-block-propertyandvalue-horizontal">
                            <div class="ds-block-propertyandvalue-horizontal-property">
                                {{ 'MONTHLY_PRICE' | translate }}
                            </div>
                            <div class="ds-block-propertyandvalue-horizontal-value">
                                <span *ngIf="instance.plan==='free'" class="plan-free">0€</span>
                                <span *ngIf="instance.plan==='shared'" class="plan-profesional">{{pricesIntances.shared}}€ + IVA</span>
                                <span *ngIf="instance.plan==='profesional'" class="plan-profesional">{{pricesIntances.profesional}}€ + IVA</span>
                                <span *ngIf="instance.plan==='enterprise'" class="plan-profesional">{{pricesIntances.enterprise}}€ + IVA</span>
                            </div>
                        </div>
                        <div class="ds-block-propertyandvalue-horizontal">
                            <div class="ds-block-propertyandvalue-horizontal-property">
                                {{ 'NEXT_PAYMENT' | translate }}
                            </div>
                            <div class="ds-block-propertyandvalue-horizontal-value">
                                {{calculeNextDayToPay(instance.createdAt) | date:'dd/MM/yyyy' }}
                            </div>
                        </div>
                        <div class="ds-block-propertyandvalue-horizontal">
                            <div class="ds-block-propertyandvalue-horizontal-property">
                                {{"CANCEL_PLAN" | translate}}
                            </div>
                            <div class="ds-block-propertyandvalue-horizontal-value" style="color: rgb(209, 0, 0); text-decoration: underline; cursor: pointer;">
                                {{"CANCEL_PLAN" | translate}}
                            </div>
                        </div>
                    </div>
                    
                </div>
                <br>

                <ng-container  *ngIf="!userCard">
                    <div class="ds-accounts-body-box-title">
                      {{ 'PAYMENT_METHOD' | translate }}
                    </div>

                    <div class="ds-accounts-body-box-subtitle">
                        {{ 'NO_CHARGE_ON_CARD_VERIFICATION' | translate }}
                    </div>
            
                    <app-stripe-card [noText]="true" (uploadCardFinish)="uploadCardFinish()"></app-stripe-card>
                </ng-container>
                
                <ng-container *ngIf="userCard">
                    <div class="ds-accounts-body-box-title">
                        {{ "YOUR_CARD" | translate }}
                    </div>
                  <app-stripe-subscription [noText]="true"></app-stripe-subscription>
                </ng-container>
        
            </div>
        </div>
    </div>
</ion-content>

<div #tooltip class="custom-tooltip" id="customTooltip" *ngIf="tooltipVisible" [ngStyle]="{'top': tooltipPosition.top, 'left': tooltipPosition.left, 'width': tooltipPosition.width}">
  <app-modal-country-selector (onSelect)="onSelectCountry($event)" [searchTerm]="searchTerm"></app-modal-country-selector>
</div>
  
  



